import { WarehouseType } from '@elementary/common-ui/types';
import { AlertIntegrationType } from '@elementary/common-ui/services/gql/types';
import { DataCatalogMetaStore, IntegrationType } from 'shared/types';

export const WAREHOUSE_META_STORES_MAP: Record<
  WarehouseType,
  Array<keyof typeof DataCatalogMetaStore>
> = {
  snowflake: [],
  redshift: [],
  bigquery: [],
  databricks: [],
  postgres: [],
  athena: [],
  clickhouse: [],
  dremio: ['GLUE'],
  fabric: [],
};

export const MESSAGING_INTEGRATION_TYPES: AlertIntegrationType[] = [
  'SLACK',
  'MICROSOFT_TEAMS',
];

export const ALERT_INTEGRATION_TYPE_TO_INTEGRATION_TYPE: Record<
  AlertIntegrationType,
  IntegrationType
> = {
  SLACK: 'slack',
  MICROSOFT_TEAMS: 'microsoft_teams',
  MICROSOFT_TEAMS_BOT: 'microsoft_teams_bot',
  PAGER_DUTY: 'pager_duty',
  OPSGENIE: 'opsgenie',
  EMAIL: 'email',
};
